import React from "react";
import { ButtonStyled } from "@nike/nike-design-system-components";

function PgConfirmModal({
  show,
  title,
  children,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  singleAction = false,
  backdropClassName = "",
  modalClassName = "",
}) {
  if (!show) {
    return null;
  }

  return (
    <div
      className={`pg-modal-backdrop ${backdropClassName}`.trim()}
      role="presentation"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onCancel();
        }
      }}
    >
      <div
        className={`pg-modal ${modalClassName}`.trim()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="pg-modal-title"
      >
        <div className="pg-modal__header">
          <div className="pg-modal__title" id="pg-modal-title">{title}</div>
          <button type="button" className="pg-modal__close" onClick={onCancel} aria-label="Close">
            ×
          </button>
        </div>
        <div className="pg-modal__body">{children}</div>
        <div className="pg-modal__footer">
          {singleAction ? (
            <ButtonStyled
              appearance="primary"
              type="button"
              className="pg-btn-reset"
              onClick={onCancel}
            >
              {cancelLabel}
            </ButtonStyled>
          ) : (
            <>
              <ButtonStyled
                appearance="primary"
                type="button"
                className="pg-btn-reset"
                onClick={onCancel}
              >
                {cancelLabel}
              </ButtonStyled>
              <ButtonStyled
                appearance="primary"
                type="button"
                className="pg-btn-apply"
                onClick={(e) => {
                  e.stopPropagation();
                  onConfirm();
                }}
              >
                {confirmLabel}
              </ButtonStyled>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default PgConfirmModal;
